/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createEnum, EnumSet } from '@gh/core-data';

export const CONTACT_TYPE_CREDITOR_SUPLIER = 'CreditorSupplier';
export const CONTACT_TYPE_CUSTOMER = 'Customer';
export const CONTACT_TYPE_DEBTOR = 'Debtor';
export const CONTACT_TYPE_EMPLOYEE = 'Employee';
export const CONTACT_TYPE_FINCANCE_COMPANY = 'FinanceCompany';
export const CONTACT_TYPE_CITY_COMPANY = 'CityCounty';
export const CONTACT_TYPE_OTHER = 'Other';

export const ContactType = createEnum('CONTACT_TYPE', {
  CreditorSupplier: 'CS',
  Customer: 'CT',
  Debtor: 'DB',
  Employee: 'EE',
  FinanceCompany: 'FC',
  CityCounty: 'CC',
  Other: 'OT',
});

export type ContactType = EnumSet<typeof ContactType>;
